const initHeaderScroll = () => {
    document.addEventListener("DOMContentLoaded", function () {
        const header = document.getElementById("masthead");

        if (!header) return;

        window.addEventListener("scroll", function () {
            if (window.scrollY > 10) {
                header.classList.add("scrolled");
            } else {
                header.classList.remove("scrolled");
            }
        });

        const mobileMenuButton = document.querySelector(".toogle-menu");
        const mobileMenuNav = document.querySelector(".mobile-menu-nav");
        const iconMenu = mobileMenuButton.querySelector(".icon-menu");
        const iconCloseMenu = mobileMenuButton.querySelector(".icon-close-menu");

        mobileMenuButton.addEventListener("click", function () {
            mobileMenuNav.classList.toggle("active");
            mobileMenuButton.classList.toggle("active");
        });
    });
}

export default initHeaderScroll;
;